import * as THREE from 'three';

/**
 * 创建 Three.js 场景
 * 深色科技风场景配置
 */
export function createScene(): THREE.Scene {
  const scene = new THREE.Scene();

  // 深色科技背景
  scene.background = new THREE.Color(0x0a0a0a);

  // 移除雾效 - 提升性能
  scene.fog = null;

  return scene;
}

/**
 * 创建背景网格 - 画布风格，简化版本
 */
export function createBackgroundGrid(scene: THREE.Scene): THREE.Group {
  const gridGroup = new THREE.Group();
  gridGroup.name = 'backgroundGrid';

  // 创建单层网格（简化）
  const gridSize = 60;
  const gridDivisions = 30;

  const gridHelper = new THREE.GridHelper(gridSize, gridDivisions, 0x666666, 0x555555);
  (gridHelper.material as THREE.Material).transparent = true;
  (gridHelper.material as THREE.Material).opacity = 0.5;
  gridHelper.position.y = -0.01;
  gridGroup.add(gridHelper);

  scene.add(gridGroup);
  return gridGroup;
}

/**
 * 设置光照系统 - 简化版本
 */
export function setupLights(scene: THREE.Scene): void {
  // 环境光
  const ambientLight = new THREE.AmbientLight(0xffffff, 0.25);
  scene.add(ambientLight);

  // 主方向光
  const mainLight = new THREE.DirectionalLight(0xffffff, 0.6);
  mainLight.position.set(10, 20, 10);
  scene.add(mainLight);

  // 顶部点光源
  const topLight = new THREE.PointLight(0xffffff, 0.3, 80);
  topLight.position.set(0, 30, 0);
  scene.add(topLight);

  scene.userData.lights = {
    ambient: ambientLight,
    main: mainLight,
    fill: mainLight,
    top: topLight
  };
}

export type { THREE };
